import {AppContext} from '../../../context/AppProvider';
import {useContext, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import { librarySearch } from '../../../lib/utils';
import CarouselSection from '../../common/CarouselSection';
import { APPROUTES, constants } from '../../../assets/constants/constants';
import { Button } from 'alm-react-components';
import { useNavigate } from 'react-router-dom';

const RecommendedSection = ({ keyword,addBookMark,  deleteBookMark }: any) => {
  const { state, dispatch } = useContext(AppContext);
  const { t } = useTranslation();
  const navigate=useNavigate()
  
  useEffect(() => {
    if (keyword) {
      const searchResult = librarySearch(
        keyword,
        state?.libraryData?.Recommended
      );

      dispatch({
        type: "SEARCH_LIBRARY_DATA",
        payload: { ...state.searchLibraryData, Recommended: searchResult },
      });
    }
  }, [keyword]);
  
  return (
    <>
      {keyword ? (
        <>
          {state?.searchLibraryData?.Recommended?.length ? (
            <div className="mt-24 mb-12 xl:px-32 lg:px-8 md:px-8 px-5">
              <h2 className="text-3xl font-barlowLight pt-16">
                <span dangerouslySetInnerHTML={{ __html: (t("Common.recommendedContent")) }} />{" "}
                {state?.user?.fields?.displayName
                  ? state?.user?.fields?.displayName
                  : state?.user?.name}
              </h2>
              {keyword ? (
                <>
                  <CarouselSection
                    data={state?.searchLibraryData?.Recommended}
                    addBookMark={addBookMark}
                    deleteBookMark={deleteBookMark}
                    id={""}
                    type={constants.RECOMMENDED}
                    from={APPROUTES.library}
                  />
                </>
              ) : state?.libraryData?.Recommended?.length > 0 ? (
                <CarouselSection
                  data={state?.libraryData?.Recommended}
                  addBookMark={addBookMark}
                  deleteBookMark={deleteBookMark}
                  id={""}
                  type={constants.RECOMMENDED}
                  from={APPROUTES.library}
                />
              ) : (
                <div className="flex w-full justify-center text-2xl mb-10 mt-12">
                  <span dangerouslySetInnerHTML={{ __html: (t("Common.noRecommendedContent")) }} />
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </>
      ) : (
        <>
          <div className="mt-24 mb-12 xl:px-32 lg:px-8 md:px-8 px-5">
          <div className="flex flex-wrap justify-between md:flex-nowrap">
            <h2 className="text-3xl font-barlowLight max-md:mb-4">
              <span dangerouslySetInnerHTML={{ __html: (t("Common.recommendedContent")) }} />{" "}
              {state?.user?.fields?.displayName
                ? state?.user?.fields?.displayName
                : state?.user?.name}
            </h2>
            <Button
          variant="outline"
          onClick={() => navigate(APPROUTES.recomendedContent)}
          className="text-base font-normal px-6 py-1 h-9 dark:bg-fillMidGrayCard border-0"
        >
          <span dangerouslySetInnerHTML={{ __html: (t('Common.seeAll')) }} />
        </Button>
</div>

            {keyword ? (
              <>
                <CarouselSection
                  data={state?.searchLibraryData?.Recommended}
                  addBookMark={addBookMark}
                  deleteBookMark={deleteBookMark}
                  id={""}
                  type={constants.RECOMMENDED}
                  from={APPROUTES.library}

                />
              </>
            ) : state?.libraryData?.Recommended?.length > 0 ? (
              <CarouselSection
                data={state?.libraryData?.Recommended}
                addBookMark={addBookMark}
                deleteBookMark={deleteBookMark}
                id={""}
                type={constants.RECOMMENDED}
                from={APPROUTES.library}
              />
            ) : (
              <div className="flex w-full justify-center text-2xl mb-10 mt-12">
                <span dangerouslySetInnerHTML={{ __html: (t("Common.noRecommendedContent")) }} />
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default RecommendedSection;
